module.exports = "/_next/static/images/thumbnail-af6c16da3bcd5f207e40e7487799b851.jpeg";